import React, { useState, useEffect } from 'react';
import MuiAvatar from '@mui/material/Avatar';
import { styled } from 'styled-components';

interface AvatarProps {
	children?: React.ReactNode;
	className?: string;
	sx?: any;
	src?: string;
	alt?: string;
}

export default function Avatar(props: AvatarProps) {
	const { children, className, sx = {}, src, alt } = props;
	const [imgError, setImgError] = useState(false);
	const [retryCount, setRetryCount] = useState(0);

	useEffect(() => {
		// Reset error state when src changes
		setImgError(false);
		setRetryCount(0);
	}, [src]);

	const handleImageError = () => {
		console.error('Failed to load avatar image:', src);
		if (retryCount < 2) {
			// Retry loading the image after a delay
			setTimeout(() => {
				setImgError(false);
				setRetryCount((prev) => prev + 1);
			}, 1000 * (retryCount + 1)); // Exponential backoff
		} else {
			setImgError(true);
		}
	};

	// If we've had too many errors, don't even try to load the image
	const shouldShowImage = !imgError && retryCount < 3;

	return (
		<MuiAvatar
			className={className}
			sx={sx}
			src={shouldShowImage ? src : undefined}
			alt={alt}
			imgProps={{
				onError: handleImageError,
				crossOrigin: 'anonymous',
				referrerPolicy: 'no-referrer',
			}}
		>
			{(!shouldShowImage || !src) && children}
		</MuiAvatar>
	);
}
